// extracted by mini-css-extract-plugin
export default {"products":"ms-z","card":"ns-z","oosMessaging":"os-z"};